import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getReviewHelpTimelineV1 } from 'services/performanceReview';

export const useTimelineDataQuery = ({ selectedReviewCycle }) =>
  useQuery(
    [REACT_QUERY_KEYS.reviews.reviewTimeline, selectedReviewCycle],
    () => getReviewHelpTimelineV1({ reviewCycleId: selectedReviewCycle?.uuid }),
    {
      enabled: !!selectedReviewCycle && selectedReviewCycle?.reviewType !== 'TRIGGERED',
      staleTime: 60000,
    }
  );

export const useTimelineViewDataQuery = ({ selectedReviewCycle, feedbackFormId }) => {
  const { data: reviewHelpTimelineData, ...rest } = useTimelineDataQuery({
    selectedReviewCycle,
  });

  if (reviewHelpTimelineData) {
    const specificViewTimelineData = reviewHelpTimelineData.find(({ feedbackFormId: ffId }) => ffId === feedbackFormId);
    return {
      feedbackTimelines: specificViewTimelineData?.feedbackTimelines,
      ...rest,
    };
  }

  return {
    reviewHelpTimelineData,
    ...rest,
  };
};
